export const formatCurrency = (amount, currency = 'USD') => {
    if (!amount && amount !== 0) return '';
    
    // Special handling for HUF (no decimal places)
    const options = {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: currency === 'HUF' ? 0 : 2,
        maximumFractionDigits: currency === 'HUF' ? 0 : 2
    };

    return new Intl.NumberFormat('en-US', options).format(amount);
};